import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, login, register, error } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok =
      mode === "login"
        ? await login(email, password)
        : await register(email, password, name);
    setBusy(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "var(--ds-bg)" }}>
      {/* Hero image side */}
      <div
        className="hidden lg:flex relative bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://static.prod-images.emergentagent.com/jobs/f15a1e8d-6de5-4e76-8fdf-e1c7ff9f0a18/images/2b8994756ecb39455d5320b9e999b5e65de1eb469bb2e9830847d9438341b082.png')",
        }}
      >
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(180,107,82,0.55), rgba(61,43,31,0.35))" }} />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white max-w-xl">
          <h1 className="font-brand text-5xl xl:text-6xl font-light leading-tight tracking-tight">
            Benvenuti in<br />Webo24.
          </h1>
          <p className="font-secondary mt-6 text-white/90 leading-relaxed text-base">
            WebOrganization 24 — il tuo gestionale di magazzino sempre attivo.
            Prodotti, ordini, fornitori e movimenti: tutto sotto controllo, 24/7.
          </p>
        </div>
      </div>

      {/* Form side */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md ds-fade-in">
          <div className="mb-10 lg:hidden">
            <Logo />
          </div>
          <div className="hidden lg:block mb-10">
            <Logo size={48} />
          </div>

          <h2 className="font-brand text-4xl font-medium mb-2" style={{ color: "var(--ds-text-primary)" }}>
            {mode === "login" ? "Accedi" : "Registrati"}
          </h2>
          <p className="text-sm mb-8" style={{ color: "var(--ds-text-secondary)" }}>
            {mode === "login"
              ? "Inserisci le credenziali per accedere"
              : "Crea un nuovo account per iniziare"}
          </p>

          <form onSubmit={submit} className="space-y-5" data-testid="auth-form">
            {mode === "register" && (
              <div>
                <Label className="label-tag">Nome</Label>
                <Input
                  data-testid="auth-name-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Il tuo nome"
                  className="mt-1.5 rounded-lg"
                />
              </div>
            )}
            <div>
              <Label className="label-tag">Email</Label>
              <Input
                data-testid="auth-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@esempio.it"
                className="mt-1.5 rounded-lg"
              />
            </div>
            <div>
              <Label className="label-tag">Password</Label>
              <Input
                data-testid="auth-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1.5 rounded-lg"
              />
            </div>

            {error && (
              <div
                className="text-sm p-3 rounded-lg border"
                style={{ color: "var(--ds-danger)", borderColor: "var(--ds-danger)", background: "rgba(139,58,54,0.05)" }}
                data-testid="auth-error"
              >
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={busy}
              data-testid="auth-submit-button"
              className="w-full ds-btn-primary text-base py-6 rounded-lg"
              style={{ background: "var(--ds-primary)" }}
            >
              {busy ? "Attendere..." : mode === "login" ? "Accedi" : "Registrati"}
            </Button>

            <button
              type="button"
              onClick={() => setMode(mode === "login" ? "register" : "login")}
              className="w-full text-sm hover:underline pt-2"
              style={{ color: "var(--ds-text-secondary)" }}
              data-testid="auth-mode-toggle"
            >
              {mode === "login"
                ? "Non hai un account? Registrati"
                : "Hai già un account? Accedi"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
